import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router';

import { AppContext } from '../../../../lib/Context';

/*

  The Link component is just a simple wrapper around the react-router Link component.
  It adds no additional markup or styling and exists to simply add additional
  functionality that requires no additional props be passed in. Currently it just
  dispatches click integration actions, but can be used to add other non-intrusive
  behavior in the future. To add integration action data to the click events,
  simply wrap this component in AppContextIntegrationData in the parent's render
  function. All props provided to simple/Link will be passed through to the underlying
  react-router Link component.

*/
const Link = React.memo(props => {
  const context = React.useContext(AppContext);
  const {
    action: { clicked },
    getActionData,
  } = get(context, 'integration', {});
  const { onClick, children, ...restProps } = props;

  const memoizedOnClick = React.useCallback(
    e => {
      if (!onClick && !props.to) return;
      if (clicked && getActionData) {
        clicked({
          ...getActionData(),
          destinationUrl: e.currentTarget.pathname,
        });
      }
      if (onClick) {
        onClick(e);
      }
    },
    [onClick, clicked, getActionData, props.to],
  );

  return (
    <RouterLink onClick={memoizedOnClick} {...restProps}>
      {children}
    </RouterLink>
  );
});

Link.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  to: PropTypes.string,
};

export default Link;
